import axios from '@/utils/request'

export const apiGetUser = (data) => axios.get('/getUser', data)
// 获取登录信息
export const getUserInfo = (data) => axios.get('/getLoginedInfo', data)

// 首页初始化 所有类别新闻
export const getAllNews = () => axios.post('/party/init')
// 根据类别查询新闻
export const getTypeNews = (data) => axios.post('/party/findByType', data)
// 根据id获取新闻详情
export const getNewsInfo = (data) => axios.get('/party/findNewsById', data)
// 全局模糊查询新闻
export const searchNews = (data) => axios.get('/party/search', data)

// 首页轮播图
export const getBanners = () => axios.post('/party/getNewsBannerList')
